import { app } from '../../../../../../app';
import { Controller } from './shared-folder-add-note.controller';

app.component('companySharingCenterSharedFoldersAddNote', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./shared-folder-add-note.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/add-note/shared-folder-add-note.component.js